export default {
      id: "warranty-claim-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#warranty-claim-usage",
      toString: function () {
        return this.url;
      }
    }